<template>
  <article>
    <tab-list
      :tab-list="tabList"
      :status.sync="tabSelected"
      @tab-change="onTabChange">
    </tab-list>
    <group v-if="dataList && dataList !== 'empty'">
      <cell v-for="(item, index) in tabDetail[tabSelected]" :key="index">
        <p slot="after-title" class="statistic-title">{{ item.title }}</p>
        <p slot="after-title" v-for="innerItem in item.item" :key="innerItem.key">{{ `${innerItem.name}${renderItem(innerItem)}` }}</p>
      </cell>
    </group>
    <div v-if="dataList === 'empty'" class="empty-list">暂无数据</div>
  </article>
</template>
<script>
import {
  Cell,
  Group
} from '@lx-frontend/cvux'
import TabList from '../components/TabList'

import cache from '../../common/cache'
import util from '../../common/util'

export default {
  components: {
    Cell,
    Group,
    TabList
  },
  data() {
    return {
      tabList: [
        { key: 'today', name: '今日' },
        { key: 'thisMonth', name: '本月' },
        { key: 'yesterday', name: '昨日' },
        { key: 'lastMonth', name: '上月' }
      ],
      tabSelected: 'today',
      tabDetail: {
        today: [
          {
            title: '今日跟进邀约',
            item: [{
              name: '今日跟进：',
              key: 'followed_invited.followed_up'
            }, {
              name: '今日邀约：',
              key: 'followed_invited.invited',
              format: (data) => {
                return `${data.followed_invited.invited} (转化率${this.parseRate(data.followed_invited.conversion_rate)}%)`
              }
            }]
          },
          {
            title: '今日预约到店',
            item: [{
              name: '今日预约：',
              key: 'booked_fulfiled.booked'
            }, {
              name: '预约到店：',
              key: 'booked_fulfiled.fulfilled',
              format: (data) => {
                return `${data.booked_fulfiled.fulfilled} (到店率${this.parseRate(data.booked_fulfiled.arrival_rate)}%)`
              }
            }, {
              name: '准时到店：',
              key: 'booked_fulfiled.fulfilled_on_time',
              format: (data) => {
                return `${data.booked_fulfiled.fulfilled_on_time} (准时率${this.parseRate(data.booked_fulfiled.on_time_rate)}%)`
              }
            }]
          },
          {
            title: '明日预约数量',
            item: [{
              name: '明日预约：',
              key: 'tomorrow_booked.tomorrow_booked',
              format: (data) => {
                return `${data.tomorrow_booked.tomorrow_booked} (${data.tomorrow_booked.fulfilled_in_advance}个提前到店)`
              }
            }]
          }
        ],
        thisMonth: [
          {
            title: '本月累计',
            item: [{
              name: '本月跟进：',
              key: 'month_total.followed_up'
            }, {
              name: '本月预约：',
              key: 'month_total.booked',
              format: (data) => {
                return `${data.month_total.booked} (转化率${this.parseRate(data.month_total.conversion_rate)}%)`
              }
            }, {
              name: '预约到店：',
              key: 'month_total.fulfilled'
            }, {
              name: '准时到店：',
              key: 'month_total.fulfilled_on_time'
            }]
          }
        ],
        yesterday: [
          {
            title: '昨日跟进邀约',
            item: [{
              name: '昨日跟进：',
              key: 'followed_invited.followed_up'
            }, {
              name: '昨日邀约：',
              key: 'followed_invited.invited',
              format: (data) => {
                return `${data.followed_invited.invited} (转化率${this.parseRate(data.followed_invited.conversion_rate)}%)`
              }
            }]
          },
          {
            title: '昨日预约到店',
            item: [{
              name: '昨日预约：',
              key: 'booked_fulfiled.booked'
            }, {
              name: '预约到店：',
              key: 'booked_fulfiled.fulfilled',
              format: (data) => {
                return `${data.booked_fulfiled.fulfilled} (到店率${this.parseRate(data.booked_fulfiled.arrival_rate)}%)`
              }
            }, {
              name: '准时到店：',
              key: 'booked_fulfiled.fulfilled_on_time',
              format: (data) => {
                return `${data.booked_fulfiled.fulfilled_on_time} (准时率${this.parseRate(data.booked_fulfiled.on_time_rate)}%)`
              }
            }]
          }
        ],
        lastMonth: [
          {
            title: '上月累计',
            item: [{
              name: '上月跟进：',
              key: 'month_total.followed_up'
            }, {
              name: '上月预约：',
              key: 'month_total.booked',
              format: (data) => {
                return `${data.month_total.booked} (转化率${this.parseRate(data.month_total.conversion_rate)}%)`
              }
            }, {
              name: '预约到店：',
              key: 'month_total.fulfilled',
              format: (data) => {
                return `${data.month_total.fulfilled} (到店率${this.parseRate(data.month_total.arrival_rate)}%)`
              }
            }, {
              name: '准时到店：',
              key: 'month_total.fulfilled_on_time',
              format: (data) => {
                return `${data.month_total.fulfilled_on_time} (准时率${this.parseRate(data.month_total.on_time_rate)}%)`
              }
            }]
          }
        ]
      },
      queryType: 'getDailyDaily',
      queryData: {},
      dataList: null
    }
  },
  mounted() {
    const now = new Date()
    this.queryData = {
      today: util.formatTime(now, 'yyyy-MM-dd'),
      thisMonth: `${util.formatTime(now, 'yyyy-MM')}-01`,
      yesterday: util.getYesterday(now),
      lastMonth: `${util.getLastMonth(util.formatTime(now, 'yyyy-MM'))}-01`,
      storeId: this.customized.store_config.store_id
    }
    this.$nextTick(() => {
      this.getData()
    })
  },
  methods: {
    onTabChange(key) {
      this.queryType = key === 'today' || key === 'yesterday' ? 'getDailyDaily' : 'getDailyMonthly'
      this.dataList = null
      this.$nextTick(() => {
        this.getData()
      })
    },
    getData() {
      this.switchLoading({ status: true, text: '加载中...' })
      this.$rest.appointment[this.queryType]({
        date: this.queryData[this.tabSelected],
        store_id: this.queryData.storeId
      }).then(res => {
        if (res.code === 0) {
          this.dataList = res.data || 'empty'
        } else {
          this.showToast(res.message)
        }
      }).finally(() => {
        this.switchLoading({ status: false })
      })
    },
    parseRate(data) {
      if (data === null || data === '--') return '--'
      return (data / 100).toFixed(2)
    },
    renderItem(item) {
      if (item.format) return item.format(this.dataList).replace(/null/g, '--')
      return item.key.split('.').reduce((acc, cur) => acc[cur] === null ? '--' : acc[cur], this.dataList)
    }
  }
}
</script>

<style scoped lang="less">
  .statistic-title {
    font-weight: bold;
  }
  .empty-list {
    text-align: center;
  }
</style>
